module.exports = __webpack_public_path__ + "img/new_spotd6.bac278e6.gif";